import { Breadcrumbs, Li, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Col, Container, Pagination, Row } from 'react-bootstrap';
import '../../../Assets/css/mjstatic.css';
import axios from 'axios';
import { base_url, postHeader } from '../../../Helpers/request';
import { Link, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ArrowBlack from '../../../Assets/images/arrowcircleright2.svg';
import moment from 'moment';

const Blog = () => {
  const [bloglist, setBloglist] = useState([]);
  const [blogcategory, setBlogCategory] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [category, setCategory] = useState('');
  const history = useHistory();
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);

  const [currentPage, setCurrentPage] = useState(1);
  const [blogPerPage, setBlogPerPage] = useState(12);
  const pageNum = [...Array(Math.ceil(bloglist.length / blogPerPage) + 1).keys()].slice(1);

  useEffect(() => {
    list();
    axios
      .get(base_url + '/common/blog_category', {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setBlogCategory(res.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    list();
  }, [category]);

  const list = () => {
    axios
      .post(
        base_url + '/common/blog_list',
        { category_id: category },
        {
          headers: postHeader,
        },
      )
      .then((res) => {
        if (res.data.status == 1) {
          let list = [];
          setBloglist(res.data.data);
          res.data.data?.map((val) => {
            list.push({ id: val.blog_url, src: val.blog_image, height: val.height, width: val.width });
          });
          setPhotos(list);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const [value, setValue] = React.useState('');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  console.log('bloglist', bloglist);

  const lastBlog = currentPage * blogPerPage;
  const firstBlog = lastBlog - blogPerPage;
  const currentBlogs = bloglist.slice(firstBlog, lastBlog);

  const onPrevPage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo(0, 50);
    }
  };

  const onNextPage = () => {
    if (currentPage !== pageNum.length) {
      setCurrentPage(currentPage + 1);
      window.scrollTo(0, 50);
    }
  };

  //

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Diamonds for Less Blog</title>
        <meta name="description" content="Read blogs on diamond wedding bands, princess cut diamonds, Engagement Rings and more. Keep yourself updated about the trending engagement rings." />
        <meta name="keywords" content={metaDetails?.keywor}></meta>
      </Helmet>
      <div className="rcs_cart_section blog-breadcrumb mt-5">
        <Container>
          <Row>
            <Col>
              <din className="rcs_top_heading m-0 text-center">
                <h1 className="m-0">Our Blog</h1>
                <div className="rcs_breadcrumb mt-2 d-flex align-items-center justify-content-center">
                  <Breadcrumbs>
                    <NavLink underline="hover" color="inherit" to="/">
                      Home
                    </NavLink>
                    <Typography color="text.primary">Blog</Typography>
                  </Breadcrumbs>
                </div>
              </din>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="rcs_education_cotnent_pages rcs_education_cotnent_pages_blog mt-5">
        <Container>
          <Row className="w-100 m-auto">
            {currentBlogs.map((blog) => (
              <Col xl={4} lg={6} md={6} key={blog.id}>
                <div className="blog-item">
                  <span>
                    <img style={{ cursor: 'pointer' }} onClick={() => history.push(`${blog.blog_url}`)} src={blog.blog_image} alt={blog.blog_name} />
                  </span>

                  <div className="content">
                    <Row>
                      <Col>{blog.category_name && <h5 className="category">{blog.category_name}</h5>}</Col>
                      <Col>
                        <p className="author m-0">{`By ${blog.author_name}`}</p>
                      </Col>
                    </Row>
                    <Link className="mt-3 w-100" to={`${blog.blog_url}`}>
                      {blog.blog_name}
                    </Link>
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="pub-date m-0">{moment(blog?.publish_date).format('MMMM DD, YYYY')}</p>
                      <Link to={`${blog.blog_url}`}>
                        <img className="m-0" src={ArrowBlack} alt={blog.blog_name} />
                      </Link>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          <Pagination className="pagination-blog list-unstyled justify-content-center">
            <Pagination.Prev onClick={onPrevPage} />
            {pageNum.map((num) => (
              <Pagination.Item
                className={currentPage === num ? 'active' : null}
                onClick={() => {
                  setCurrentPage(num);
                  window.scrollTo(0, 60);
                }}
              >
                {num}
              </Pagination.Item>
            ))}
            <Pagination.Next onClick={onNextPage} />
          </Pagination>
        </Container>
      </div>
    </>
  );
};
export default Blog;
